// TODO: We should get rid of code duplicating

let cachedVideoElement: HTMLVideoElement | null = null;

export const getVideoElement: () => HTMLVideoElement = () => {
  if (cachedVideoElement) {
    return cachedVideoElement;
  }

  cachedVideoElement = document.createElement('video');
  return cachedVideoElement;
};

export const emulatePlayOnVideoElement: () => Promise<void> = () => getVideoElement().play();
